import { CheckCircle, XCircle } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import tickImage from "../../assets/images/greenTick.svg";
import crossImage from "../../assets/images/crossImage.svg";
import xclose from '../../assets/icons/x-close.svg';
import { Image } from "react-bootstrap";

const Alert = (type, message) => {
  console.log("message in alert", type,message);
  
  const options = {
    className: `toast-${type}`,
  };

  let toastId;
  const handleClose = () => {
    if (toastId) {
      toast.dismiss(toastId);
    }
  };

  switch (type) {
    case 'warning':
      toastId = toast.warning(message, options);
      break;
    case 'error':
      toastId = toast.error( <div className="error-contain">
        <div className="error-image">
          <img src={crossImage} alt="Verified" />
          <span className="errorName">ERROR</span>
        </div>
        <span className="toast-message">{message}</span>
        <Image src={xclose} onClick={handleClose} className="cross-btn-alert" />
      </div>,
      { ...options });
      break;
    case 'success':
      toastId = toast.success(
        <div className="success-contain">
          <div className="success-image">
            <img src={tickImage} alt="Verified" />
            <span className="successName">SUCCESS</span>
          </div>
          <span>{message}</span>
          <Image src={xclose} onClick={handleClose} className="cross-btn-alert" />
        </div>,
        { ...options }
      );
      
      break;
    case 'info':
      toastId = toast.info(message, { ...options, theme: 'colored', style: { background: '#FFFFFF' } });
      break;
    case 'dark':
      toastId = toast.dark(message, options);
      break;
    default:
      toastId = toast(message, options);
      break;
  }

  setTimeout(() => {
    toast.dismiss(toastId);
  }, 5000);
};

export default Alert;
